import { Link } from "react-router-dom";
import { Badges, P, SVG } from "../../../AbstractElements";
import { Href } from "../../../utils/Constant";
// import { Rating } from "react-simple-star-rating";
// import { dynamicImage } from "../../../Service";
import { TableColumn } from "react-data-table-component";
import { RechargeAmountTableDataColumnType, RechargeAmountTableOffer } from "../../../Types/Application/Ecommerce/Ecommerce";
import Swal from "sweetalert2";
import api from "../../../utils/api";

export const RechargeListTableData = [
  {
    cardRechargeMasterId: 1,
    cardAmount: 1000,
  },
  {
    cardRechargeMasterId: 2,
    cardAmount: 2000,
  },
];

// const RfidCardListTableAction = () => {
//   return (
//     <div className="product-action">
//       <Link to={Href}>
//         <SVG iconId="edit-content" style={{ fill: 'blue' }} />
//       </Link>
//       <SVG iconId="trash1" style={{ fill: 'red' }}/>
//     </div>
//   );
// };

const handleDelete = async (id: number) => {
  // Your delete logic here (API call, state update, etc.)
  // console.log("Deleting ID:", id);
 try {
        await api.delete(`/api/CardRechargeMaster/DeleteRechargeAmount?rechargeAmountId=${id}`);
       Swal.fire('Deleted!', 'Record has been deleted.', 'success');
      } catch (error) {
        Swal.fire('Error!', 'Failed to delete the record.', 'error');
        console.error("Delete error:", error);
      }
};

interface ProductListTableActionProps {
  cardRechargeMasterId: any;
  onDelete: (id: number) => void;
}

export const RechargeAmountTableAction: React.FC<ProductListTableActionProps> = ({ cardRechargeMasterId, onDelete }) => {
  const editUrl = `/rfid_card/edit/${cardRechargeMasterId}`;

  const handleDeleteClick = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        onDelete(cardRechargeMasterId);
      }
    });
  };

  return (
    <div className="product-action d-flex gap-2">
      <Link to={editUrl}>
        <SVG iconId="edit-content" style={{ fill: 'blue' }} />
      </Link>
      <button className="btn btn-sm" onClick={handleDeleteClick}>
        <SVG iconId="trash1" style={{ fill: 'red' }} />
      </button>
    </div>
  );
};

export const RechargeAmountTableOfferComponent: React.FC<RechargeAmountTableOffer> = ({ title }) => {
  return (
    <div className="product-names my-2">
      <P>{title}</P>
    </div>
  );
};

export const RechargeAmountTableStatus :React.FC<RechargeAmountTableOffer> = ({ title }) => {
  return (
    <Badges color="" className={`badge-light-${title === "Active" ? "secondary" : "primary" }`}>{title}</Badges>
  );
};

export  const RechargeAmountListTableDataColumn: TableColumn<RechargeAmountTableDataColumnType>[] = [
      {
        name: "Amount",
        cell: (row) => <RechargeAmountTableOfferComponent title={String(row.cardAmount)}/>,
        sortable: true,
        grow: 2,
      },
      {
        name: "Action",
        cell: (row) => <RechargeAmountTableAction cardRechargeMasterId={row.cardRechargeMasterId} onDelete={handleDelete} />,
      },
    ];

  export const filtersData = [
    {
      name: "Choose RFID Card",
      options: ["Adult122", "Child222"],
    },
    {
      name: "Status",
      options: ["Active", "Inactive"],
    },
  ];